import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getTemplates = (data: PropertyType): Promise<PropertyType> =>
	api.post(`/user/report-filter-templates-names`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
